import React from 'react';
import styled from 'styled-components';
import { PitchBreakdownFilter } from 'yankees-react-utils';

const StyledWrapper = styled.div`
    margin-top: 12px;
    && > div {
        border: 1px solid rgb(188, 200, 209) !important;
        background-color: white;
    }
`;

const Filters = ({ filter, setFilter }) => (
    <StyledWrapper>
        <PitchBreakdownFilter
            filter={filter}
            setFilter={setFilter}
            availableResultTypes={new Set([1, 2, 3, 4, 5, 6, 7, 8])}
            hidePitcherHand
            isSwitch
        />
    </StyledWrapper>
);

export default Filters;
